import axios from "axios";
import { getSession } from "../authActions";
import { Apis, BaseUrl } from "../../config";
import { toast } from "react-toastify";

export const serviceList = (facilityId) => async (dispatch) => {
  const { token, user_profile_id, role_id } = getSession();

  dispatch({ type: "serviceList_req" });
  try {
    const response = await axios.get(
      //`${BaseUrl}${Apis.servicelist}${facilityId}`,
      `${BaseUrl}${Apis.servicelist}`,

      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params: {
          svcf_id: facilityId,
          sys_user_id: user_profile_id,
          role_id: role_id,
        },
      }
    );
    dispatch({ type: "serviceList_success", payload: response?.data });
  } catch (error) {
    dispatch({
      type: "serviceList_failure",
      payload: error?.response?.data,
    });

    //toast.error(error.response.data.usr.message);
  }
};

//service delete
export const deleteService = (selectedId) => async (dispatch) => {
  const { token, role_id, user_profile_id } = getSession();

  dispatch({ type: "serviceList_req_delete" });
  try {
    const response = await axios.put(
      `${BaseUrl}${Apis.serviceUrl}/${selectedId}`,
      {
        svc_active_yn: "N",
        sys_user_id: user_profile_id,
        role_id: role_id,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch({ type: "serviceList_delete_success", payload: response.data });

    toast.success(response?.data?.usr?.message);
  } catch (error) {
    console.log(error);

    dispatch({
      type: "serviceList_delete_failure",
      payload: error?.response?.data,
    });

    toast.error(error?.response?.data?.usr?.message);
  }
};
//create service
export const createService = (values) => async (dispatch) => {
  const { token } = getSession();

  dispatch({ type: "add_service_req" });
  try {
    const response = await axios.post(`${BaseUrl}${Apis.serviceUrl}`, values, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
      },
    });
    //console.log(response, "response:::::::::");
    dispatch({ type: "add_service_success", payload: response?.data });

    toast.success(response.data.usr.message);
  } catch (error) {
    //console.log(error, "errror:::::::::::");
    dispatch({
      type: "add_service_failure",
      payload: error?.response?.data?.usr?.message,
    });

    toast.error(error.message);
  }
};

//service edit
export const editServiceUpdate = (values, svc_id) => async (dispatch) => {
  const { token } = getSession();

  dispatch({ type: "edit_service_req" });
  try {
    const response = await axios.put(
      `${BaseUrl}${Apis.serviceUrl}/${svc_id}`,
      values,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch({ type: "edit_service_success", payload: response.data });

    toast.success(response.data.usr.message);
  } catch (error) {
    dispatch({
      type: "edit_service_failure",
      payload: error.response.data,
    });

    toast.error(error?.response?.data?.usr?.message);
  }
};

export const setserviceData = (data) => (dispatch) => {
  dispatch({ type: "set_service_details", payload: data });
};
